import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { GeopostMuiPopup } from 'components/geopostMuiPopup/GeopostMuiPopup';
import { GeopostPopup } from 'components/geopostPopup/GeopostPopup';
import { Position } from 'components/geopostPopup/models/enums/Position';
import { use3DGridStore } from 'features/seismic-3d/stores/use3DGridStore';
import { use3DViewerStore } from 'features/seismic-3d/stores/use3DViewerStore';
import { SeismicsList } from '../SeismicsList';
import { SelectedSeismicsListRow } from './SelectedSeismicsListRow';

interface ISelectedSeismicPopupProps {
    height: number | string;
    width: number | string;
    top: number | string;
    left: number | string;
    open: boolean;
    onClose: () => void;
}

export const SelectedSeismicsPopup = ({open, onClose, height, width, top, left} : ISelectedSeismicPopupProps) => {
    const selectedVolumes = use3DGridStore(state => state.selectedVolumes);
    const removeSelectedVolume = use3DGridStore(state => state.removeSelectedVolume);

    return (
        <GeopostPopup
            open={open}
            onChangeOpen={(opened) => !opened && onClose()}
            height={height}
            width={width}
            position={Position.middleLeft}
            title='Selected seismics'
            temporaryIgnoreFlexInContainer={false}
            overlay={false}
        >
            <TableContainer>
                <Table size='small' stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Details
                            </TableCell>
                            <TableCell>
                                Name
                            </TableCell>
                            <TableCell>
                                Display grid
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            selectedVolumes.map(volume => <SelectedSeismicsListRow seismicData={volume} selected={true} onToggle={(checked) => !checked && removeSelectedVolume(volume)} />)
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </GeopostPopup>
    );
};